import styled, { css } from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { AddCircleIcon, RemoveCircleIcon } from '@root/styles/icons';

export const QuantityPickerWrapper = styled.div`
  display: flex;
  align-items: center;

  svg {
    color: ${({ theme }) => theme.primaryColour};
  }
`;

export const IconButton = styled.button`
  padding: 0;
  border: none;
  background: transparent;
  outline: none;
  border-radius: 100%;
  margin: 0 6px;

  &:hover {
    box-shadow: 0px 3px 6px #00000029;
    cursor: pointer;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.brandColors.primary};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: normal;
  }
`;

const smallStyle = css`
  ${media.lg`
    width: 28px;
    height: 28px;
  `}
`;
const styledIcon = (Icon) => styled(Icon)`
  width: 47px;
  height: 47px;
  margin: -3px;
  color: ${({ theme }) => theme.customColors.primary};
  ${({ small }) => (small ? smallStyle : '')}
`;

export const MinusCircleIcon = styledIcon(RemoveCircleIcon);

export const PlusCircleIcon = styledIcon(AddCircleIcon);

export const QuantityValue = styled.input`
  width: 24px;
  text-align: center;
  outline: none;
  padding-left: 0;
  padding-right: 0;
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  border: 0;
  pointer-events: none;
  background: transparent;

  &:focus {
    border-width: 2px;
    border-style: inset;
    border-color: initial;
  }
`;
